import { GET_USER_CAMPAIGNS_SUCCESS } from '../constants/campaigns';

export default (state = [], action) => {
  switch (action.type) {
    case GET_USER_CAMPAIGNS_SUCCESS:
      if (action && action.payload && action.payload.length > 0) {
        return [...action.payload];
      }
      return [];
    default:
      return state;
  }
};
